import React from 'react'
import * as Request from '../../utilities/request'
import { User } from '../../../../back-end/common/users'
import type { AppState } from '../../App.d'
import LcLoadingImage from '../../images/xero-logo.svg'

const LoadingImages = LcLoadingImage

interface NoAccessProps {
	appState: AppState
}

const NoAccess = (props: NoAccessProps) => {
	const [users, setUsers] = React.useState<User[] | null>()

	React.useEffect(() => {
		let isMounted = true

		const getUsers = async () => {
			const users = await Request.get('user')
			if (isMounted) {
				setUsers(users.data.users)
			}
		}

		if (props.appState.authState.isLoggedIn) {
			getUsers()
		}

		return () => {
			isMounted = false
		}
	}, [props.appState])

	return (
		<div>
			{users ? (
				<p>You do not have access to this {props.appState.permission.roleID ? 'account' : 'product'}.</p>
			) : (
				<div className="loading-gif">
					<img src={LoadingImages} alt="Loading ..." />
				</div>
			)}
		</div>
	)
}

export default NoAccess
